/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupReleaseResponsePayload
 */
export interface LookupReleaseResponsePayload {
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    releaseId: string;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    releaseTitle: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupReleaseResponsePayload
     */
    sourceReleaseId: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    edgeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupReleaseResponsePayload
     */
    releaseLabels?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupReleaseResponsePayload
     */
    catNumbers?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    mediaType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    format?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupReleaseResponsePayload
     */
    barcode?: string | null;
}

/**
 * Check if a given object implements the LookupReleaseResponsePayload interface.
 */
export function instanceOfLookupReleaseResponsePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    isInstance = isInstance && "sourceReleaseId" in value;

    return isInstance;
}

export function LookupReleaseResponsePayloadFromJSON(json: any): LookupReleaseResponsePayload {
    return LookupReleaseResponsePayloadFromJSONTyped(json, false);
}

export function LookupReleaseResponsePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupReleaseResponsePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'releaseTitle': json['releaseTitle'],
        'sourceReleaseId': json['sourceReleaseId'],
        'edgeId': !exists(json, 'edge_id') ? undefined : json['edge_id'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
    };
}

export function LookupReleaseResponsePayloadToJSON(value?: LookupReleaseResponsePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'releaseTitle': value.releaseTitle,
        'sourceReleaseId': value.sourceReleaseId,
        'edge_id': value.edgeId,
        'dateReleased': value.dateReleased,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
        'barcode': value.barcode,
    };
}

